import React from "react";

const Footer =() =>{
return(
<footer className="footer-main">
    &copy; Copyright 2015 - 2022, DISH L.L.C., all rights reserved.
</footer>
)
}

export default Footer;